import {Controller as BaseController} from "@hotwired/stimulus"

export default class extends BaseController<HTMLElement> {
  static values = {
    content: String,
    copy: String,
    copied: String,
  }

  declare readonly contentValue: string
  declare readonly copyValue: string
  declare readonly copiedValue: string

  static targets = ["message", "button"]

  declare messageTarget: HTMLElement

  startCopy() {
    this.messageTarget.innerText = this.copiedValue;
  }

  finishCopy() {
    this.messageTarget.innerText = this.copyValue;
  }

  copy() {
    console.log(this.contentValue);

    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.contentValue)
    }
    // Compatible with old browsers such as Chrome <=65, Edge <=18 & IE
    // Compatible with HTTP
    else if (document.queryCommandSupported?.('copy')) {
      const textarea = document.createElement('textarea')
      textarea.value = this.contentValue

      textarea.style.position = 'fixed' // Avoid scrolling to bottom
      textarea.style.opacity = '0'

      document.body.appendChild(textarea)
      textarea.select()

      // Security exception may be thrown by some browsers
      try {
        document.execCommand('copy')
      } catch (e) {
        console.error(e)
      } finally {
        document.body.removeChild(textarea)
      }
    } else {
      console.error('Copy failed.')
    }

    if (this.copiedValue && this.copyValue) {
      this.messageTarget.innerText = this.copiedValue;

      this.startCopy();

      setTimeout(() => this.finishCopy(), 1000);
    }
  }
}
